import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticCarsWithoutLicenseMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()

    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({make, version}) => {
    const hasMake = Boolean(make)
    const hasVersion = Boolean(version)

    switch (true) {
      case hasMake && hasVersion:
        return 'make-version'
      case hasMake:
        return 'make'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {make, version}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      make,
      version
    })

    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
